export default "__VITE_ASSET__n6YdzTQ4__"